import { lensPath, set } from "ramda";

/** separates by a dot (some.name => [some,name]) or
 * by square brackets (some.name[someArrIndex] => [some, name, someArrIndex]) */
export const DEFAULT_NESTING_RULE = /\]?\.|\[/;

export function setObjectValue<T>(object: T, path: string, value): T {
  const lens = lensPath(path.split(DEFAULT_NESTING_RULE));
  return set(lens, value, object);
}
